<div *ngIf="!editing" class="editable-text">{{value}}</div>
<form *ngIf="editing" class="form-inline" role="form" novalidate [formGroup]="form">
    <div>
        <label class="form-label" for="editable" class="visually-hidden">{{name | sqMessage}}</label>
        <input [sqValidation]="form" type="text" id="editable" formControlName="editable" spellcheck="false" class="form-control" (keydown)="inputKeydown($event)" sqAutofocus (blur)="stopEditing()">
    </div>
</form>
